import { ThunkDispatch } from 'redux-thunk'
import { connect } from 'react-redux'
import { AnyAction } from 'redux'

import { IDisplayDispatchProps } from './types'
import { IStateProps } from '../types'
import { fetchSsoRealms, deleteSsoRealm } from '../../../../store/ssoRealms/actions'
import { fetchInstallations } from '../../../../store/installations/actions'
import { IState } from '../../../../store/types'
import { TSSORealm } from '../../../../types/ssoRealm'
import { Display } from './Display'

const mapStateToProps = (state: IState): IStateProps => {
  return {
    ssoRealms: state.ssoRealms,
    installations: state.installations,
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, AnyAction>): IDisplayDispatchProps => {
  return {
    fetchSsoRealms: () => {
      return dispatch(fetchSsoRealms())
    },
    fetchInstallations: () => {
      return dispatch(fetchInstallations())
    },
    deleteSsoRealm: (ssoRealm: TSSORealm) => {
      return dispatch(deleteSsoRealm(ssoRealm))
    }
  }
}

const DisplayContainer = connect(mapStateToProps, mapDispatchToProps)(Display)

export {
  DisplayContainer
}
